import { loadModuleDirectly } from '../../../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { EntityTypeStore } from '../EntityTypeStore';

export default function getTypes()
{
    return loadModuleDirectly(EntityTypeStore).bespoke.types;
}
